import React, { useEffect, useRef, useState } from "react";
import { useLanguage } from '../../components/hooks/LanguageContext'; // <-- хук

const Industries = () => {
    const { language } = useLanguage();

    const itemsContent = {
        ru: [
            {
                iconClass: 'fi fi-rr-glass-cheers',
                title: 'Рестораны',
                description: 'Спрогнозируем, где открывать бургерную, чтобы туда ломились даже в дождь.'
            },
            {
                iconClass: 'fi fi-rr-house-building',
                title: 'Девелопмент',
                description: 'Найдём точку, где новостройка взлетит, а не будет пылиться с пустыми окнами.'
            },
            {
                iconClass: 'fi fi-rr-bank',
                title: 'Госсектор',
                description: 'Определим, где поставить остановку, чтобы бабушки не шли пешком три километра.'
            },
            {
                iconClass: 'fi fi-rr-shop',
                title: 'Маркетплейсы & Логистика',
                description: 'Поставим ПВЗ туда, где за него скажет спасибо весь район.'
            }
        ],
        en: [
            {
                iconClass: 'fi fi-rr-glass-cheers',
                title: 'Restaurants',
                description: 'We’ll identify where to open your outlet to ensure strong footfall — rain or shine.'
            },
            {
                iconClass: 'fi fi-rr-house-building',
                title: 'Property Development',
                description: 'We’ll find the location where a new development will thrive, not stand empty.'
            },
            {
                iconClass: 'fi fi-rr-bank',
                title: 'Public Sector',
                description: 'We’ll locate optimal infrastructure, like bus stops, so that accessibility is maximised.'
            },
            {
                iconClass: 'fi fi-rr-shop',
                title: 'Marketplaces & Logistics',
                description: 'We’ll position your pickup points where the community will benefit most.'
            }
        ]
    };

    const items = itemsContent[language];

    const wrappersRef = useRef([]);
    const [maxHeight, setMaxHeight] = useState(0);

    useEffect(() => {
        if (wrappersRef.current.length) {
            const heights = wrappersRef.current.map(el => el?.offsetHeight || 0);
            setMaxHeight(Math.max(...heights));
        }
    }, [items]);

    return (
        <section data-bs-version="5.1" className="features22 cid-uGVx9CHyO3" id="features022-16">
            <div className="container-fluid">
                <div className="row mb-5 justify-content-center">
                    <div className="col-12 content-head">
                        <h3 className="mbr-section-title mbr-fonts-style align-center mb-0 display-2">
                            <strong>{language === 'ru' ? 'Решения для разных отраслей' : 'Solutions for Different Industries'}</strong>
                        </h3>
                    </div>
                </div>
                <div className="row mbr-masonry" data-masonry='{"percentPosition":true}'>
                    {items.map((item, index) => (
                        <div
                            key={index}
                            className="item features-without-image item-mb"
                            ref={el => wrappersRef.current[index] = el}
                        >
                            <div
                                className="item-wrapper"
                                style={{ height: maxHeight ? `${maxHeight}px` : "auto" }}
                            >
                                <div className="card-box align-left">
                                    <div className="iconfont-wrapper">
                                        <span className={`mbr-iconfont ${item.iconClass}`}></span>
                                    </div>
                                    <h5 className="card-title mbr-fonts-style display-5">
                                        <strong>{item.title}</strong>
                                    </h5>
                                    <p className="card-text mbr-fonts-style display-7">{item.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Industries;
